import React, { Fragment, useState } from "react";
import Modal from "react-responsive-modal";
import ButtonCommonComponent from "../common/ButtonCommonComponent";
import ProjectCoordinatorDetails from "../common/ProjectCoordinatorDetails";

export default function AgencyDashboardContactDetailsOneModal() {
  const [values, setValues] = useState({
    open: false,
    isDisplayContactDetails: false,
  });

  const onOpenModal = () => {
    setValues({
      open: true,
    });
  };

  const onCloseModal = () => {
    setValues({
      open: false,
      isDisplayContactDetails: values.isDisplayContactDetails,
    });
  };

  const handleOnClickBtnYes = () => {
    setValues({
      ...values,
      isDisplayContactDetails: true,
    });
  };

  const renderText1 = (text1) => {
    return (
      <h2 className="font-24-NunitoSans-600 color-white-66 mb-23">{text1}</h2>
    );
  };

  const renderText2 = (text2) => {
    return <h3 className="font-48-NunitoSans-600 mb-88">{text2}</h3>;
  };

  return (
    <>
      <ButtonCommonComponent
        extraClassName="login-btn--req-contact mb-25"
        onClick={onOpenModal}
        text="Request Contact"
      />

      <Modal
        open={values.open}
        onClose={onCloseModal}
        closeOnEsc={true}
        closeOnOverlayClick={false}
        center
        classNames={{
          overlay: "customOverlay",
          modal: "customModal customModal--contactDetails",
          closeButton: "customCloseButton",
        }}
      >
        <span className="closeIconInModal" onClick={onCloseModal} />
        <Fragment>
          {!values.isDisplayContactDetails ? (
            <>
              {renderText1(
                "Are you sure you want to get contact details for the requirement"
              )}
              {renderText2("3 MERN Stack Developers")}
              <div className="pt-25 text-center">
                <ButtonCommonComponent
                  extraClassName="login-btn--modal-btn-border mr-30"
                  text="No"
                  onClick={onCloseModal}
                />
                <ButtonCommonComponent
                  text="Yes"
                  onClick={handleOnClickBtnYes}
                />
              </div>
            </>
          ) : (
            <>
              {renderText1("Here are the details requested for")}
              {renderText2("3 MERN Stack Developers")}
              <ProjectCoordinatorDetails
                name="Rajesh Tripathi"
                email="RajeshT123@gmail.com"
                phone="+91-23124123123"
              />
              <div className="pt-25 text-center">
                <ButtonCommonComponent
                  extraClassName="login-btn--modal-btn-border"
                  text="Ok"
                  onClick={onCloseModal}
                />
              </div>
            </>
          )}
        </Fragment>
      </Modal>
    </>
  );
}
